import AuthNav from './authNav';

export default AuthNav;
